"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_TRACK_DRAFT_KEY = exports.initialMilestones = exports.initialRewardTrack = exports.rewardTrackReducer = exports.setErrors = exports.clearDraft = exports.setDraftMilestone = exports.setDraft = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
// a track being created has no id yet, so its draft lives under this key
var NEW_TRACK_DRAFT_KEY = "new";
exports.NEW_TRACK_DRAFT_KEY = NEW_TRACK_DRAFT_KEY;
var initialMilestones = [
    {
        index: 0,
        name: "",
        source_value: 0,
        target_value: 0,
        image_url: "",
        colour: "",
        file: null,
        isFileEdited: false,
    },
];
exports.initialMilestones = initialMilestones;
var initialRewardTrack = {
    name: "",
    start_date: null,
    end_date: null,
    keep_target_on_reset: false,
    milestone_count: 1,
    source: "",
    target: "",
    reward_track_type: undefined,
    milestones: initialMilestones,
};
exports.initialRewardTrack = initialRewardTrack;
var initialState = {
    drafts: {},
    errors: {},
};
var withMilestones = function (track) {
    return !(track === null || track === void 0 ? void 0 : track.milestones) || track.milestones.length === 0 ? __assign(__assign({}, track), { milestones: initialMilestones }) : track;
};
var slice = (0, toolkit_1.createSlice)({
    name: "rewardTrackState",
    initialState: initialState,
    reducers: {
        setDraft: function (state, action) {
            state.drafts[action.payload.key] = withMilestones(action.payload.track);
        },
        setDraftMilestone: function (state, action) {
            var draft = state.drafts[action.payload.key];
            if (draft)
                draft.milestones[action.payload.milestone.index] = action.payload.milestone;
        },
        clearDraft: function (state, action) {
            delete state.drafts[action.payload];
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
    },
});
var _a = slice.actions, setDraft = _a.setDraft, setDraftMilestone = _a.setDraftMilestone, clearDraft = _a.clearDraft, setErrors = _a.setErrors;
exports.setDraft = setDraft;
exports.setDraftMilestone = setDraftMilestone;
exports.clearDraft = clearDraft;
exports.setErrors = setErrors;
var rewardTrackReducer = slice.reducer;
exports.rewardTrackReducer = rewardTrackReducer;
